// extracted by mini-css-extract-plugin
export default {"arrow":"Arrow_arrow__3VN9e","right":"Arrow_right__vcQw9","bottom":"Arrow_bottom__9euVa","top":"Arrow_top__j6lsd"};